import React from 'react';

import { SubscribeDiv, Container, SubscribeHeading, SubscribeLink } from './style';

const Subscribe = () => (
    <SubscribeDiv>
        <Container>
            <SubscribeHeading>
                Subscribe to our newsletter
            </SubscribeHeading>
            <SubscribeLink href="http://eepurl.com/g8S8D9" target="_blank" rel="noreferrer noopener">Subscribe</SubscribeLink>
        </Container>
    </SubscribeDiv>
);

export default Subscribe;